import { hideAndRemoveAllActiveArrays, hideAndRemoveInArr } from "../scripts/changeObjectParams/helpers";

export const deleteAllObj = () => {
    hideAndRemoveAllActiveArrays();
    servObj.active = null;
    servObj.isEditMode = false;

    hideAndRemoveInArr(servObj.building._all);
    hideAndRemoveInArr(servObj.building._objects);
    hideAndRemoveInArr(servObj.building._columns);
};

export const deleteObj = (obj) => {
    if (!obj) return;

    // Удаляем из сцены
    if (obj.parent) {
        obj.parent.remove(obj);
    }

    // Выключаем видимость
    obj.visible = false;

    // Удаляем из массивов через filter
    ["_all", "_objects", "_columns"].forEach((key) => {
        servObj.building[key] = servObj.building[key].filter((item) => item !== obj);
    });
    servObj.active = null;
    // Очищаем активные массивы
    hideAndRemoveAllActiveArrays();
};
